<h2>Promos</h2>

<mat-spinner *ngIf="initializing"></mat-spinner>

<div class="button_row" *ngIf="!initializing">
    <button mat-raised-button
            (click)="back()">Back</button>
    <button mat-raised-button
            color="primary"
            (click)="newPromo()"><mat-icon>add</mat-icon> New Promo</button>
</div>

<div *ngIf="promos?.length && !initializing" class="paginator_row">
    <span>
        <mat-checkbox [checked]="!excludeInactive"
                      (change)="inactiveFilterChanged($event)">Include Inactive</mat-checkbox>
        <mat-checkbox [checked]="!excludeInstitutional"
                      (change)="instFilterChanged($event)">Include Institutional</mat-checkbox>
    </span>

    <mat-paginator #paginator
                   [hidden]="initializing"
                   [length]="promos.length"
                   [pageIndex]="INITIAL_PAGE_INDEX"
                   [pageSize]="INITIAL_PAGE_SIZE"
                   [pageSizeOptions]="[5, 10, 20]"
                   (page)="pageChanged($event)"></mat-paginator>
</div>
<table mat-table *ngIf="promos?.length && !initializing"
       [dataSource]="promoRange">

    <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Code</th>
        <td mat-cell *matCellDef="let promo">{{promo.code}}</td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let promo">{{formatType(promo)}}</td>
    </ng-container>

    <ng-container matColumnDef="discount">
        <th mat-header-cell *matHeaderCellDef>Discount</th>
        <td mat-cell *matCellDef="let promo">
            <span *ngIf="promo.type=='amount_off'">{{promo.discount | currency}}</span>
            <span *ngIf="promo.type=='percent_off'">{{promo.discount | number:'1.0-2'}}%</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="left">
        <th mat-header-cell *matHeaderCellDef>Left</th>
        <td mat-cell *matCellDef="let promo">
            <span *ngIf="promo.initial_inventory">{{promo.inventory | number:'1.0-0'}} of {{promo.initial_inventory | number:'1.0-0'}}</span>
            <span *ngIf="!promo.initial_inventory" class="larger">&infin;</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="expires">
        <th mat-header-cell *matHeaderCellDef>Expires</th>
        <td mat-cell *matCellDef="let promo">{{formatTime(promo.expires)}}</td>
    </ng-container>

    <ng-container matColumnDef="institutional">
        <th mat-header-cell *matHeaderCellDef class="diag"><div>Institutional</div></th>
        <td mat-cell *matCellDef="let promo"><mat-icon *ngIf="promo.institutional">check</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="disabled">
        <th mat-header-cell *matHeaderCellDef class="diag"><div>Disabled</div></th>
        <td mat-cell *matCellDef="let promo"><mat-icon *ngIf="promo.disabled">check</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="expired">
        <th mat-header-cell *matHeaderCellDef class="diag"><div>Expired</div></th>
        <td mat-cell *matCellDef="let promo"><mat-icon *ngIf="promo.expired">check</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="exhausted">
        <th mat-header-cell *matHeaderCellDef class="diag"><div>Exhausted</div></th>
        <td mat-cell *matCellDef="let promo"><mat-icon *ngIf="promo.exhausted">check</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="inactive">
        <th mat-header-cell *matHeaderCellDef class="diag"><div>Inactive</div></th>
        <td mat-cell *matCellDef="let promo"><mat-icon *ngIf="promo.inactive">check</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let promo">
            <mat-icon class="link" (click)="edit(promo)" title="Edit">edit</mat-icon>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row
        *matRowDef="let promo; columns: columnsToDisplay"
        [ngClass]="{inactive: promo.inactive}"></tr>

</table>

